import {
  addDesignerItemToFolder,
  addDesignerItemToSubfolder,
  createDesignerFolder,
  createDesignerSubfolder,
  deleteDesignerFolder,
  deleteDesignerSubfolder,
  listDesignerFolders,
  removeDesignerItemFromFolder,
  removeDesignerItemFromSubfolder,
  renameDesignerFolder,
  renameDesignerSubfolder
} from "../../designer-folder-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const folderTools: ToolHandlerGroup = {
  sync: {
    ui_project_list_folders: (input) => listDesignerFolders(getSdInstance(), input),
    ui_project_create_folder: (input) => createDesignerFolder(getSdInstance(), input),
    ui_project_rename_folder: (input) => renameDesignerFolder(getSdInstance(), input),
    ui_project_delete_folder: (input) => deleteDesignerFolder(getSdInstance(), input),
    ui_project_add_item_to_folder: (input) => addDesignerItemToFolder(getSdInstance(), input),
    ui_project_remove_item_from_folder: (input) => removeDesignerItemFromFolder(getSdInstance(), input),
    ui_project_create_subfolder: (input) => createDesignerSubfolder(getSdInstance(), input),
    ui_project_rename_subfolder: (input) => renameDesignerSubfolder(getSdInstance(), input),
    ui_project_delete_subfolder: (input) => deleteDesignerSubfolder(getSdInstance(), input),
    ui_project_add_item_to_subfolder: (input) => addDesignerItemToSubfolder(getSdInstance(), input),
    ui_project_remove_item_from_subfolder: (input) => removeDesignerItemFromSubfolder(getSdInstance(), input)
  }
};
